export enum LoginRouting {
  BASE_PATH = 'login/',
  PARTICULAR = 'particulares',
  BUSINESS = 'empresas',
  USER_SESION = 'user-session',
  AUTH_OPTIONS = 'auth-options',
  FORGOT_PASSWORD = 'forgotPassword',
  TEMPORAL = 'temporal',
  PHONE = 'phone',
  MAIL = 'mail',
  CREATE_PASSWORD = 'create-password'
}

export interface LoginWhySignupItems {
  icon: string;
  title: string;
  desc: string;
  srv: string;
}
export interface LoginTopOperationsItems {
  img: string;
  title: string;
  message: string;
}

export interface LoginShortCutCards {
  icon: string;
  text: string;
}

export interface LoginFooterLinks {
  type: string;
  links: LoginFooterLink[];
}
export interface LoginFooterLink {
  text: string;
  url: string;
}
export interface SocialMediaFooterIcon {
  path: string;
  url: string;
}


export interface ResultLoginButton {
  text: string;
  src?: string;
  show?: boolean;
  icon?: string;
  slot?: 'end' | 'start';
  onClick?: () => void;
  class?: string;
  state?: any;
  type?: 'primary' | 'dark' | 'clear' | 'link';
}

export interface ResultLoginButtons {
  primary: ResultLoginButton,
  secondary: ResultLoginButton,
  reverse: boolean;
}

export interface ResultLoginInput {
  label?: string,
  value?: string,
  button?: {
    type: 'primary' | 'dark' | 'clear' | 'link' | 'borderD'
    title?: string,
    onClick?: () => void
  }
}

export interface ResultLoginOptions {
  data: {
    titleHi?: string;
    title?: string;
    message?: string;
    infoCall?: boolean;
    infoCallMessage?: string;
    imgDesktop?: string;
    imgMobile?: string;
    inputs?: ResultLoginInput[];
    infoDesktop?: boolean;
    errMtC?: string;
  },
  buttons: Partial<ResultLoginButtons>;
}
